// extracted by mini-css-extract-plugin
module.exports = {"root":"UnlinkButton_root__1JTZ8"};